import React from 'react';
import SearchInput from 'src/components/inputs/search';
import i18n from 'i18next';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

export default class ErrorPage extends React.Component  {

  componentDidMount() {
    trackFootfallEvent(footfallEventTypes.SAW_OOPS_PAGE);
  }

  render() {
    return <div className="error-page">
        <h1 className="error-page__title">{i18n.t('Oops. Looks like that page no longer exists!')}</h1>
        <h2 className="error-page__sub-title">{i18n.t('Try a search')}</h2>
        <div className="error-page__search">
          <SearchInput className="" size="full" />
        </div>
      </div>;
  }
};



// WEBPACK FOOTER //
// ./src/components/error.js